export interface GetDefaultParameterCollectionsRequest {
  configBranchCode: string
  searchType: string
}

export function GetDefaultParameterCollectionsRequestToJSON(
  value: GetDefaultParameterCollectionsRequest
): any {
  return {
    config_branch_code:
      value.configBranchCode !== '' ? value.configBranchCode : undefined,
    search_type: value.searchType !== '' ? value.searchType : undefined
  }
}
